import { type UseModalState } from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";

import { ClipboardScoreActions } from "../../utils/constants";
import { RestrictedNudgeBottomSheet } from "./RestrictedNudgeBottomSheet";

interface WorkerLeftEarlyBottomSheetProps {
  modalState: UseModalState;
}

export function WorkerLeftEarlyBottomSheet(props: WorkerLeftEarlyBottomSheetProps) {
  const { modalState } = props;

  useLogEffect(
    APP_V2_USER_EVENTS.CLIPBOARD_SCORE_NO_SHOW_BOTTOM_SHEET_VIEWED,
    {},
    { enabled: modalState.modalIsOpen }
  );

  return (
    <RestrictedNudgeBottomSheet
      modalState={modalState}
      action={ClipboardScoreActions.WORKER_LEFT_EARLY_WITHOUT_PERMISSION}
    />
  );
}
